import { Switch } from "@chakra-ui/react";
import { useOrdersKanbanStore } from "../../../stores/kanban.store";

const OrdersHaltedFilter = () => {
	const {
		filters: { halted },
		setFilterHalted,
	} = useOrdersKanbanStore();

	return (
		<Switch
			colorScheme="brand"
			isChecked={halted === true}
			onChange={() => setFilterHalted(!halted)}
		>
			En pause
		</Switch>
	);
};

export default OrdersHaltedFilter;
